export const academics = {
  'settings.tab.subjects': 'المواد',
  'settings.tab.schoolDay': 'الدوام والحصص',
  'settings.tab.terms': 'الفصول الدراسية',
  'academics.subjects.title': 'المواد الدراسية',
  'academics.subjects.hint': 'المواد التي تدرّسها المدرسة والصفوف التي تأخذ كل مادة. يستخدمها الجدول الدراسي، ثم الواجبات والدرجات.',
  'academics.subjects.add': 'مادة جديدة',
  'academics.subjects.defaults': 'إضافة المواد المعتادة',
  'academics.subjects.defaultsDone': 'أُضيفت المواد المعتادة ({n})',
  'academics.subjects.defaultsNone': 'المواد المعتادة موجودة كلها',
  'academics.subjects.empty': 'لا مواد بعد',
  'academics.subjects.emptyBody': 'ابدأ بالمواد المعتادة في بلدك ثم عدّلها، أو أضف مادة بنفسك.',
  'academics.subjects.grades': 'الصفوف',
  'academics.subjects.noGrades': 'لم تُحدَّد صفوف',
  'academics.subjects.allStreams': 'كل الأقسام',
  'academics.subjects.archived': 'مؤرشفة',
  'academics.subjects.archive': 'أرشفة',
  'academics.subjects.restore': 'إعادة',
  'academics.subjects.nameAr': 'اسم المادة',
  'academics.subjects.nameEn': 'الاسم بالإنجليزية',
  'academics.subjects.editTitle': 'تعديل المادة',
  'academics.subjects.newTitle': 'مادة جديدة',
  'academics.subjects.gradesHint': 'اختر الصفوف التي تأخذ المادة. في الصفوف ذات الأقسام اختر الأقسام، أو اتركها فارغة لكل الأقسام.',
  'academics.subjects.saved': 'حُفظت المادة',
  'academics.day.title': 'الدوام والحصص',
  'academics.day.hint': 'أيام الدوام وأوقات الحصص. إن اختلف دوام مرحلة (مثلاً الابتدائي) أضف لها دواماً خاصاً.',
  'academics.day.weekDays': 'أيام الدوام',
  'academics.day.weekSaved': 'حُفظت أيام الدوام',
  'academics.day.builtIn': 'تستخدم المدرسة الدوام الافتراضي: ست حصص من الساعة ٨:٠٠. عدّله ليناسب مدرستكم: بداية الدوام، عدد الحصص، مدتها والاستراحات.',
  'academics.day.add': 'دوام آخر',
  'academics.day.name': 'الاسم',
  'academics.day.namePlaceholder': 'مثلاً: الابتدائي',
  'academics.day.defaultName': 'الدوام',
  'academics.day.default': 'الافتراضي',
  'academics.day.defaultHint': 'تتبعه كل الصفوف غير المخصّصة لدوام آخر.',
  'academics.day.makeDefault': 'جعله الدوام الافتراضي',
  'academics.day.grades': 'الصفوف التي تتبع هذا الدوام',
  'academics.day.periods': 'الحصص',
  'academics.day.period': 'الحصة {n}',
  'academics.day.addPeriod': 'إضافة حصة',
  'academics.day.removePeriod': 'حذف آخر حصة',
  'academics.day.saved': 'حُفظ الدوام',
  'academics.day.edit': 'تعديل',
  'academics.day.newTitle': 'دوام جديد',
  'academics.day.editTitle': 'تعديل الدوام',
  'academics.terms.title': 'الفصول الدراسية',
  'academics.terms.hint': 'فصول السنة الدراسية {year}. تستخدمها الدرجات والشهادات.',
  'academics.terms.suggested': 'هذا اقتراح بتقسيم السنة إلى فصلين؛ راجعه واحفظه.',
  'academics.terms.name': 'اسم الفصل',
  'academics.terms.start': 'البداية',
  'academics.terms.end': 'النهاية',
  'academics.terms.add': 'فصل آخر',
  'academics.terms.remove': 'حذف الفصل',
  'academics.terms.saved': 'حُفظت الفصول',
  'timetable.title': 'الجدول الدراسي',
  'timetable.subtitle': 'حصص كل صف خلال الأسبوع',
  'timetable.byClass': 'حسب الصف',
  'timetable.byTeacher': 'حسب المدرّس',
  'timetable.myWeek': 'جدولي',
  'timetable.class': 'الصف',
  'timetable.teacher': 'المدرّس',
  'timetable.period': 'الحصة',
  'timetable.add': 'إضافة حصة',
  'timetable.slot.title': '{day}، الحصة {n}',
  'timetable.slot.subject': 'المادة',
  'timetable.slot.teacher': 'المدرّس',
  'timetable.slot.noTeacher': 'بلا مدرّس',
  'timetable.slot.room': 'القاعة',
  'timetable.slot.clear': 'إزالة الحصة',
  'timetable.slot.otherSubjects': 'مواد أخرى',
  'timetable.busy': 'لدى {teacher} حصة {subject} في {class} من {start} إلى {end}.',
  'timetable.noSubjects': 'أضف المواد أولاً من الإعدادات ← المواد.',
  'timetable.setup': 'إعداد المواد والدوام',
  'timetable.print': 'طباعة',
  'timetable.teacherEmpty': 'لا حصص في جدول هذا المدرّس',
  'timetable.noClasses': 'لا صفوف في السنة الحالية',
  'settings.tab.teaching': 'توزيع المواد',
  'academics.teaching.title': 'توزيع المواد على المدرّسين',
  'academics.teaching.hint': 'من يدرّس كل مادة في كل شعبة. يسجّل المدرّس حضور حصصه ودرجات مادته فقط، وتأخذ حصص الجدول مدرّسها من هنا.',
  'academics.teaching.teacher': 'المدرّس',
  'academics.teaching.none': 'بلا مدرّس',
  'academics.teaching.saved': 'حُفظ المدرّس، ونُقلت حصص المادة إليه.',
  'academics.teaching.lessons': '{n} حصص أسبوعياً',
  'academics.teaching.noLessons': 'ليست في الجدول',
  'academics.teaching.noSubjects': 'لا توجد مواد لمرحلة هذه الشعبة. أضفها من «المواد».',
  'academics.teaching.noClasses': 'لا توجد شعب في السنة الدراسية الحالية',
  'academics.teaching.load': 'نصاب المدرّسين',
  'academics.teaching.loadLine': '{subjects} مواد · {lessons} حصص',
  'academics.teaching.noLoad': 'لم تُوزّع أي مادة بعد.',
  'academics.teaching.busy': 'لا يمكن: لدى المدرّس حصة {subject} في {class} من {start} إلى {end} في الوقت نفسه.',
  'timetable.slot.assignedHint': 'مدرّس المادة في هذه الشعبة: {name}',
  'academics.day.editBuiltIn': 'تعديل الدوام',
  'academics.day.break': 'استراحة {n} د',
  'academics.day.periodsHint': 'يمكن تعديل أي حصة بعد الإعداد السريع.',
  'academics.day.clash': 'لا يمكن: بهذه الأوقات تتداخل حصتان لـ{teacher} يوم {day}: {class} الساعة {start} و{otherClass} الساعة {otherStart}. غيّر الأوقات أو الحصص في الجدول أولاً.',
  'academics.day.quick': 'إعداد سريع',
  'academics.day.quickHint': 'اكتب بداية الدوام وعدد الحصص ومدتها والاستراحات، فتُحسب أوقات كل الحصص.',
  'academics.day.quickStart': 'بداية الدوام',
  'academics.day.quickCount': 'عدد الحصص',
  'academics.day.quickLength': 'مدة الحصة',
  'academics.day.quickGap': 'بين الحصص',
  'academics.day.quickBreakAfter': 'الفرصة بعد',
  'academics.day.quickNoBreak': 'بلا فرصة',
  'academics.day.quickBreakLength': 'مدة الفرصة',
  'academics.day.quickBuild': 'حساب الأوقات',
  'academics.day.quickInvalid': 'الأرقام غير صحيحة أو ينتهي الدوام بعد منتصف الليل.',
  'academics.day.minutes': 'بالدقائق',
} as const;
